import { PaginaNode } from '@gql/graphql'
import { WLink } from '../../atoms'
import styles from './PaginaCard.module.sass'

interface Props {
  className?: string
  pagina?: PaginaNode
}

const PaginaCard = (props: Props) => {
  const { className = '', pagina = undefined } = props

  return (
    <WLink className={`${styles.root} ${className}`} href={pagina?.url}>
      <span className={styles.title}>{pagina?.titolo}</span>
    </WLink>
  )
}

export default PaginaCard
